/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventAccess } from './EventAccess';
import {
    EventAccessFromJSON,
    EventAccessFromJSONTyped,
    EventAccessToJSON,
    EventAccessToJSONTyped,
} from './EventAccess';
import type { ScoringMode } from './ScoringMode';
import {
    ScoringModeFromJSON,
    ScoringModeFromJSONTyped,
    ScoringModeToJSON,
    ScoringModeToJSONTyped,
} from './ScoringMode';
import type { JudgingMode } from './JudgingMode';
import {
    JudgingModeFromJSON,
    JudgingModeFromJSONTyped,
    JudgingModeToJSON,
    JudgingModeToJSONTyped,
} from './JudgingMode';
import type { EventParticipation } from './EventParticipation';
import {
    EventParticipationFromJSON,
    EventParticipationFromJSONTyped,
    EventParticipationToJSON,
    EventParticipationToJSONTyped,
} from './EventParticipation';
import type { FeedbackLevel } from './FeedbackLevel';
import {
    FeedbackLevelFromJSON,
    FeedbackLevelFromJSONTyped,
    FeedbackLevelToJSON,
    FeedbackLevelToJSONTyped,
} from './FeedbackLevel';

/**
 * Schema for updating an event.
 * @export
 * @interface EventUpdate
 */
export interface EventUpdate {
    /**
     * 
     * @type {string}
     * @memberof EventUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {EventParticipation}
     * @memberof EventUpdate
     */
    participation?: EventParticipation | null;
    /**
     * 
     * @type {EventAccess}
     * @memberof EventUpdate
     */
    access?: EventAccess | null;
    /**
     * 
     * @type {Date}
     * @memberof EventUpdate
     */
    available_start?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EventUpdate
     */
    available_end?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof EventUpdate
     */
    duration_minutes?: number | null;
    /**
     * 
     * @type {ScoringMode}
     * @memberof EventUpdate
     */
    scoring_mode?: ScoringMode | null;
    /**
     * 
     * @type {number}
     * @memberof EventUpdate
     */
    max_team_size?: number | null;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof EventUpdate
     */
    feedback?: FeedbackLevel | null;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof EventUpdate
     */
    feedback_after_close?: FeedbackLevel | null;
    /**
     * 
     * @type {JudgingMode}
     * @memberof EventUpdate
     */
    judging_mode?: JudgingMode | null;
    /**
     * 
     * @type {number}
     * @memberof EventUpdate
     */
    judging_radius?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventUpdate
     */
    judging_tolerance?: number | null;
}



/**
 * Check if a given object implements the EventUpdate interface.
 */
export function instanceOfEventUpdate(value: object): value is EventUpdate {
    return true;
}

export function EventUpdateFromJSON(json: any): EventUpdate {
    return EventUpdateFromJSONTyped(json, false);
}

export function EventUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'participation': json['participation'] == null ? undefined : EventParticipationFromJSON(json['participation']),
        'access': json['access'] == null ? undefined : EventAccessFromJSON(json['access']),
        'available_start': json['available_start'] == null ? undefined : (new Date(json['available_start'])),
        'available_end': json['available_end'] == null ? undefined : (new Date(json['available_end'])),
        'duration_minutes': json['duration_minutes'] == null ? undefined : json['duration_minutes'],
        'scoring_mode': json['scoring_mode'] == null ? undefined : ScoringModeFromJSON(json['scoring_mode']),
        'max_team_size': json['max_team_size'] == null ? undefined : json['max_team_size'],
        'feedback': json['feedback'] == null ? undefined : FeedbackLevelFromJSON(json['feedback']),
        'feedback_after_close': json['feedback_after_close'] == null ? undefined : FeedbackLevelFromJSON(json['feedback_after_close']),
        'judging_mode': json['judging_mode'] == null ? undefined : JudgingModeFromJSON(json['judging_mode']),
        'judging_radius': json['judging_radius'] == null ? undefined : json['judging_radius'],
        'judging_tolerance': json['judging_tolerance'] == null ? undefined : json['judging_tolerance'],
    };
}

export function EventUpdateToJSON(json: any): EventUpdate {
    return EventUpdateToJSONTyped(json, false);
}

export function EventUpdateToJSONTyped(value?: EventUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'participation': EventParticipationToJSON(value['participation']),
        'access': EventAccessToJSON(value['access']),
        'available_start': value['available_start'] == null ? undefined : ((value['available_start'] as any).toISOString()),
        'available_end': value['available_end'] == null ? undefined : ((value['available_end'] as any).toISOString()),
        'duration_minutes': value['duration_minutes'],
        'scoring_mode': ScoringModeToJSON(value['scoring_mode']),
        'max_team_size': value['max_team_size'],
        'feedback': FeedbackLevelToJSON(value['feedback']),
        'feedback_after_close': FeedbackLevelToJSON(value['feedback_after_close']),
        'judging_mode': JudgingModeToJSON(value['judging_mode']),
        'judging_radius': value['judging_radius'],
        'judging_tolerance': value['judging_tolerance'],
    };
}

